export const packingStepNames = {
    PEEK: "peek",
    SCAN_WORKSTATION: "scan_workstation",
    PACK_ITEMS: "pack_items",
    WEIGH_SHIPMENT: "weigh_shipment",
    DROP_SHIPMENT: "drop_shipment",
    RENEW: "renew"
}